<template>
  <div v-if="hasAccess" class="py-4 container-fluid">
    <ToastPrime position="bottom-left" />
    <div class="card border-0" style="height: calc(100vh - 120px); display: flex; flex-direction: column;">
      <div class="card-header py-3 d-flex flex-wrap align-items-center gap-3">
        <h5 class="mb-0">Company List</h5>
        <div class="d-flex flex-wrap gap-2 flex-grow-1 justify-content-center">
          <IconField class="search-field">
            <InputIcon>
              <i class="pi pi-search" />
            </InputIcon>
            <InputText
v-model="table.search" type="text" size="small" placeholder="Search Company" class="rounded-pill"
              style="min-width: 500px;" @keyup="filter" />
          </IconField>
        </div>
        <div class="d-flex align-items-center">
          <button type="button" class="mx-1 mb-0 btn btn-sm btn-primary" @click="openAddModal">Add</button>
        </div>
      </div>
      <div style="flex: 1; overflow-y: auto;">
        <DataTable
:value="table.onLoad ? dummyRows : table.data" removable-sort scrollable scroll-height="flex"
          table-style="min-width: 100%; width: max-content;">
          <Column field="client" header="Client" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.client ? slotProps.data.client : '' }}
            </template>
          </Column>
          <Column field="code" header="Code" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.code ? slotProps.data.code : '' }}
            </template>
          </Column>
          <Column field="description" header="Description" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.description ? slotProps.data.description : '' }}
            </template>
          </Column>
          <!-- Created By -->
          <Column field="created_by" header="Created By" sortable header-class="bg-light text-dark">
            <template v-if="table.onLoad" #body>
              <Skeleton />
            </template>

            <template v-else #body="slotProps">
              {{ slotProps.data?.created_by || '-' }}
            </template>
          </Column>

          <!-- Updated By -->
          <Column field="updated_by" header="Updated By" sortable header-class="bg-light text-dark">
            <template v-if="table.onLoad" #body>
              <Skeleton />
            </template>

            <template v-else #body="slotProps">
              {{ slotProps.data?.updated_by || '-' }}
            </template>
          </Column>
          <Column field="created_at" header="Created At" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.created_at ? formatDate(slotProps.data.created_at) : '' }}
            </template>
          </Column>
          <Column
header="Actions" header-class="bg-light" :style="{ width: '150px' }"
            :body-style="{ width: '150px', padding: '0' }">
            <template v-if="table.onLoad" #body>
              <Skeleton />
            </template>
            <template v-else #body="slotProps">
              <ButtonPrime
v-tooltip.bottom="'Update'" icon="pi pi-pencil" outlined rounded size="small" class="me-2"
                @click="openEditModal(slotProps.data)" />
              <ButtonPrime
v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined rounded severity="danger"
                size="small" @click="deleteCompany(slotProps.data.id)" />
            </template>
          </Column>
          <template #empty>
            <div style="text-align: center; padding: 40px 0;">
              <img src="/no_data.png" alt="No Data" style="max-width: 330px; opacity: 0.7; margin-bottom: 0;" />
              <div style="color: #888; font-size: 1.1em; font-weight: 500;">
                No Data
              </div>
            </div>
          </template>
        </DataTable>
      </div>
      <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
        <BasePagination
v-model="table.page.current_pages" :page-count="table.page?.total_pages || 1" size="sm"
          @click="changePage()" />
        <p>
          {{ (table.page.current_pages - 1) * table.page.per_pages + table.data.length }} of {{ table.total }}
        </p>
      </div>
    </div>
    <DialogPrime v-model:visible="modal.visible" modal style="width: 30rem; margin: 10px;">
      <template #header>
        <div class="d-flex align-items-center gap-3">
          <h5 class="mb-0 fw-bold text-dark">{{ modal.action === 'create' ? 'Tambah Company' : 'Edit Company' }}</h5>
        </div>
      </template>
      <div class="mb-4">
        <label for="client" class="form-label fw-semibold">Client <span class="text-danger">*</span></label>
        <AutoComplete
id="client" v-model="modal.data.client" placeholder="Cari Client..." :suggestions="clientOptions"
          option-label="label" :force-selection="true" :invalid="!!modal.errorMessage['client']" fluid
          @complete="searchClient" />
      </div>
      <div class="mb-4">
        <label for="code" class="form-label fw-semibold">Code <span class="text-danger">*</span></label>
        <InputText
id="code" v-model="modal.data.code" placeholder="Code" :invalid="!!modal.errorMessage['code']"
          fluid />
      </div>
      <div class="mb-4">
        <label for="description" class="form-label fw-semibold">Description <span class="text-danger">*</span></label>
        <InputText
id="description" v-model="modal.data.description" placeholder="Description"
          :invalid="!!modal.errorMessage['description']" fluid />
      </div>
      <template #footer>
        <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
          <ButtonPrime
type="button" label="Cancel" severity="danger" raised size="small" class="px-4 border-0"
            @click="closeModal()" />
          <ButtonPrime
type="button" severity="contrast" raised size="small" :disabled="modal.onLoading" label="Save Company"
            class="px-4" @click="save()">
            <template v-if="modal.onLoading" #icon>
              <i class="fas fa-spinner fa-spin me-2"></i>
            </template>
          </ButtonPrime>
        </div>
      </template>
    </DialogPrime>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import BasePagination from "@/components/BasePagination.vue";
import NoAccess from "@/components/NoAccess.vue";
import moment from "moment";
import api from "@/helpers/api";
import companiesService from "@/services/generalMasterData/companiesService";
import clientService from '@/services/generalMasterData/clientService';

export default {
  components: {
    BasePagination,
    NoAccess,
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
    hasAccess() {
      return this.authUserPermissions.includes('company-view');
    },
  },
  data() {
    return {
      table: {
        onLoad: true,
        search: this.$route.query.search || "",
        total: 0,
        data: [],
        limit: 100,
        page: {
          current_pages: 1,
          per_pages: 100,
          total_pages: 1,
        },
        loadTimeout: null,
      },
      dummyRows: Array.from({ length: 10 }, () => ({})),
      modal: {
        visible: false,
        data: { client: '', code: '', description: '' },
        errorMessage: {},
        onLoading: false,
        action: '', // 'create' atau 'update'
        editId: null,
      },
      clientOptions: [],
    };
  },
  mounted() {
    if (this.hasAccess) {
      this.get();
    }
  },
  methods: {
    async get() {
      this.table.onLoad = true;
      try {
        const response = await api(
          this,
          companiesService.list({
            search: this.table.search,
            limit: this.table.limit,
            page: this.table.page.current_pages,
          }),
          false
        );
        const paged = response.data || {};
        this.table.data = paged.data || [];
        this.table.total = paged.total || this.table.data.length;
        this.table.page.total_pages = paged.last_page || 1;
        this.table.page.current_pages = paged.current_page || 1;
        this.table.page.per_pages = paged.per_page || this.table.limit;
      } catch (error) {
        this.table.data = [];
        this.table.total = 0;
        this.table.page.total_pages = 1;
      } finally {
        this.table.onLoad = false;
      }
    },
    filter() {
      clearTimeout(this.table.loadTimeout);
      this.table.loadTimeout = setTimeout(() => {
        this.$router.push({ query: this.table.search ? { search: this.table.search } : null });
        this.table.page.current_pages = 1;
        this.get();
      }, 500);
    },
    changePage() {
      this.get();
    },
    formatDate(date) {
      return date ? moment(date).format("DD MMMM YYYY, HH:mm") : "-";
    },

    // 🟢 ADD MODAL
    openAddModal() {
      this.modal.visible = true;
      this.modal.data = { client: null, code: '', description: '' };
      this.modal.errorMessage = {};
      this.modal.action = 'create';
      this.modal.editId = null;
      this.modal.onLoading = false;
    },

    // 🟡 EDIT MODAL tanpa API detail
    async openEditModal(rowData) {
      this.modal.visible = true;
      this.modal.action = 'update';
      this.modal.editId = rowData.id;

      // Ambil daftar client dari API
      try {
        const res = await api(this, clientService.list({ limit: 100 }), false);
        this.clientOptions = (res.data.data || []).map(c => ({
          label: c.label,
          value: c.code
        }));
      } catch {
        this.clientOptions = [];
      }

      // Mencari client option yang cocok dengan kode client dari rowData
      let clientValue = rowData.client || '';
      if (rowData.client) {
        const matchedClient = this.clientOptions.find(option => option.value === rowData.client);
        if (matchedClient) {
          // Set nilai client ke objek lengkap agar label ditampilkan
          clientValue = matchedClient;
        } else {
          // Jika client tidak ditemukan di daftar, tambahkan sebagai opsi
          // Ini untuk menangani kasus di mana client mungkin sudah tidak aktif atau dihapus
          // tapi masih ada di data perusahaan
          this.clientOptions.unshift({
            label: `${rowData.client} - ${rowData.description || 'Unknown'}`,
            value: rowData.client
          });
          clientValue = {
            label: `${rowData.client} - ${rowData.description || 'Unknown'}`,
            value: rowData.client
          };
        }
      }

      this.modal.data = {
        client: clientValue,
        code: rowData.code || '',
        description: rowData.description || ''
      };

      this.modal.errorMessage = {};
      this.modal.onLoading = false;
    },

    // 💾 SAVE
    async save() {
      this.modal.errorMessage = {};

      // Validasi sederhana - cek apakah string atau objek dengan field value
      if (!this.modal.data.client ||
        (typeof this.modal.data.client === 'object' && !this.modal.data.client.value && !this.modal.data.client.code)) {
        this.modal.errorMessage['client'] = 'Client wajib diisi';
      }
      if (!this.modal.data.code) this.modal.errorMessage['code'] = 'Code wajib diisi';
      if (!this.modal.data.description) this.modal.errorMessage['description'] = 'Description wajib diisi';
      if (Object.keys(this.modal.errorMessage).length > 0) return;

      this.modal.onLoading = true;
      try {
        // Ekstrak kode client dari objek jika v-model berisi objek
        let clientData = this.modal.data.client;
        if (this.modal.data.client && typeof this.modal.data.client === 'object') {
          clientData = this.modal.data.client.value || this.modal.data.client.code;
        }

        const dataToSave = {
          ...this.modal.data,
          client: clientData
        };

        if (this.modal.action === 'update' && this.modal.editId) {
          await api(this, companiesService.patch(this.modal.editId, dataToSave), true);
        } else {
          await api(this, companiesService.create(dataToSave), true);
        }
        this.modal.visible = false;
        this.get(); // refresh table
      } catch (error) {
        if (error.response?.data?.code == 400 && error.response.data.data) {
          error.response.data.data.forEach((v) => {
            this.modal.errorMessage[v.path] = v.msg;
          });
        }
      } finally {
        this.modal.onLoading = false;
        this.modal.action = '';
        this.modal.editId = null;
      }
    },

    closeModal() {
      this.modal.visible = false;
      this.modal.data = { client: null, code: '', description: '' };
      this.modal.errorMessage = {};
      this.modal.action = '';
      this.modal.editId = null;
      this.modal.onLoading = false;
    },

    async searchClient(event) {
      const query = event.query;
      if (!query || query.length < 2) {
        this.clientOptions = [];
        return;
      }
      try {
        const res = await api(this, clientService.list({ search: query, limit: 10 }), false);
        this.clientOptions = (res.data.data || []).map(c => ({ label: c.label, value: c.code }));
      } catch {
        this.clientOptions = [];
      }
    },



    async deleteCompany(id) {
      this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
        if (result.isConfirmed) {
          api(this, companiesService.delete(id)).then(() => {
            this.get();
          });
        }
      });
    },
  },
};
</script>
